import {useBleskAuth} from '@blesk-frontend/auth';
import {Button, Loader, Page} from '@blesk-frontend/ui';
import {sendToBackgroundViaRelay} from '@plasmohq/messaging';
import {useNavigate} from '@tanstack/react-router';
import {Check} from 'lucide-react';
import {useEffect, useState} from 'react';
import {sendEvent} from '@/libs/analytics';

const openSidePanel = async () => {
  return sendToBackgroundViaRelay({
    // @ts-expect-error
    name: 'open-side-panel',
  });
};

export const GuideExtensionPage = () => {
  const {token} = useBleskAuth();
  const navigate = useNavigate();
  const [inProgress, setInProgress] = useState(false);

  useEffect(() => {
    if (!token) {
      navigate({to: '/auth/signin'});
      return;
    }

    setInProgress(true);

    if (!inProgress) {
      sendEvent('auth/callback-chrome');

      setTimeout(() => {
        sendToBackgroundViaRelay<{token: string | null; open: boolean}>({
          // @ts-expect-error
          name: 'auth',
          body: {token, open: false},
        }).catch((err) => {
          console.error('Failed to send token to background:', err);
        });
      }, 100);
    }
  }, [token, inProgress, navigate]);

  const onClickGuides = () => {
    openSidePanel().then(() => {
      navigate({to: '/'});
    });
  };

  return (
    <Page className="flex min-h-full w-full items-center justify-center">
      <div className="flex max-w-lg flex-col items-center justify-center gap-6 text-center">
        {token ? (
          <>
            <div className="flex flex-col items-center justify-center gap-3">
              <Check className="size-16 text-text-secondary" />
              <div className="text-text-primary text-title-h2">Блеск готов к работе</div>
              <div className="text-paragraph-lg text-text-secondary">
                Расширение установлено и настроено
              </div>
            </div>
            <Button onClick={onClickGuides} className="px-6 py-3">
              Запустить расширение
            </Button>
          </>
        ) : (
          <div className="text-text-secondary">
            <Loader size={24} />
          </div>
        )}
      </div>
    </Page>
  );
};
